<template>
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div>
            <label for="license_type">نوع لایسنس <span class="text-danger">*</span></label>
            <select class="form-control" name="license_type" id="license_type" v-model="vLicenseType">
                <option value="business">حرفه ای</option>
                <option value="student">آموزشی (مناسب برای دانشجویان)</option>
            </select>
        </div>

        <div class="mt-3">
            <label>مبلغ قابل پرداخت</label>
            <div class="text-lg font-weight-bold text-success text-center num-fa">
                {{ vTotal.toLocaleString() }} تومان
            </div>
        </div>

        <div class="mt-3">
            <label for="discount_code">بن تخفیف</label>
            <input type="text" class="form-control" id="discount_code" name="discount_code" v-model="vDiscountCode"
                   placeholder="بن تخفیف دارید؟ اینجا وارد کنید. (بعد از ثبت، اعمال می شود.)">
        </div>
    </div>
</template>

<script>
    export default {
        name: "cadfa-price",
        data() {
            return {
                vTotal: '',
                vDiscountCode: '',
                vLicenseType: '',
            };
        },
        props: {
            product: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                default() {
                    return 'business';
                }
            },
            total: {
                type: String,
                default() {
                    return '';
                }
            },
            discount: {
                type: String,
                default() {
                    return '';
                }
            },
        },
        methods: {

        },
        watch: {
            vLicenseType() {
                this.vTotal = this.vLicenseType === 'business' ? this.product.price : this.product.price - this.product.discount;
            }
        },
        created() {
            this.vLicenseType = this.type;
            this.vTotal = this.product.price;
            this.vDiscountCode = this.discount;
        }
    }
</script>

<style scoped>

</style>
